enum TokenType {
  ACCESS = 'accessToken',
  REFRESH = 'refreshToken',
  ID = 'idToken',
  SOCKET = 'socketToken'
}

export default TokenType;
